export default "__VITE_ASSET__6b86fb0e__"